import { useContext, useEffect } from "react";
import context from "../store/context";

// import TendersLayout from "./TendersLayout";
import TendersList from "../pages/Tender/TendersList";

const TendersTelegram = () => {
  const {
    setTelegramApiPath,
    tendersPopularCategories,
    getPopularCategories,
    getCategories,
    getLanguagesAndRegions,
    getSrc,
    tendersCategoryLists,
    tendersRegions,
    tendersLanguage,
    tendersSrc,
  } = useContext(context);

  useEffect(() => {
    setTelegramApiPath("latest-tenders");
    if (tendersPopularCategories.length === 0) {
      getPopularCategories("");
    }
    if (tendersCategoryLists.length === 0) {
      getCategories("");
    }
    if (tendersRegions.length === 0 || tendersLanguage.length === 0) {
      getLanguagesAndRegions("");
    }
    if (tendersSrc.length === 0) {
      getSrc();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  window.Telegram?.WebApp?.BackButton?.hide();

  return (
    <TendersList
      filter=""
      categorySlider={true}
      showSearchSidebar={false}
      noTendersPlaceholder={<div>No result</div>}
    />
  );
};

export default TendersTelegram;
